import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBQS020RunningProcessRequest } from 'types/MCBQS020/MCBQS020RunningProcessRequest'
import { RootState } from 'reducers'
import { MCBQS020InitRequest } from 'types/MCBQS020/MCBQS020InitRequest'

const tasks = [
  { name: '選考ファイル', targetField: 'selectionFileMergeTargetInfo' as const },
  { name: 'MCBファイル', targetField: 'mcbFileMergeTargetInfo' as const },
  { name: '応募者詳細', targetField: 'applicantPdfMergeTargetInfo' as const },
  { name: 'SHLテスト結果', targetField: 'shlTestResultMergeTargetInfo' as const },
  { name: 'PDFマージ', targetField: null },
]

const mCBQS020InitRequestValue: MCBQS020InitRequest = {
  setPrintManagementId : '',
}

const mCBQS020RunningProcessRequestValue: MCBQS020RunningProcessRequest = {
  setPrintManagementId: '',
  screenDisplayToggleFlag: '0',
  jobSeekerByCompanyId: '',
  jobSeekerId: '',
  selectionFileMergeTargetInfo: [],
  mcbFileMergeTargetInfo: [],
  applicantPdfMergeTargetInfo: [],
  shlTestResultMergeTargetInfo: [],
}

interface ProcessState {
  currentIndex: number
  finished: boolean
  error: string | null
  totalTasks: number
  currentTaskName: string
  runningProcessRequestData: MCBQS020RunningProcessRequest
  initRequestData: MCBQS020InitRequest
  //companyId: string
}

interface UpdateCurrentTaskPayload {
  index: number
  name: string
}

interface jobSeekerPayload {
  jobSeekerByCompanyId: string
  jobSeekerId: string
}

const initialState: ProcessState = {
  currentIndex: 0,
  finished: false,
  error: null,
  totalTasks: tasks.length,
  currentTaskName: '',
  initRequestData: mCBQS020InitRequestValue,
  runningProcessRequestData: mCBQS020RunningProcessRequestValue,
}

const pdfProcessSlice = createSlice({
  name: 'setOutputPdfProcess',
  initialState,
  reducers: {
    // 初期表示処理
    initPdfProcess(state, action: PayloadAction<MCBQS020InitRequest>) {
      state.initRequestData.setPrintManagementId = action.payload.setPrintManagementId
      return state
    },
    // 実行メソッド確認
    updateCurrentTask(state, action: PayloadAction<UpdateCurrentTaskPayload>) {
      state.currentIndex = action.payload.index
      state.currentTaskName = action.payload.name
    },
    // 画面切り替えフラグ更新
    updateRequestData(state, action: PayloadAction<MCBQS020RunningProcessRequest>) {
      state.runningProcessRequestData = action.payload
      state.runningProcessRequestData.screenDisplayToggleFlag = action.payload.screenDisplayToggleFlag
    },
    // 初期表示処理エラー発生
    setInitPdfProcessError(state, action: PayloadAction<string>) {
      state.error = action.payload
    },
    // 「PDF作成中」ロジック実行
    setRunPdfTaskStart(state) {
      state.error = null
      state.finished = false
    },
    // 「PDF作成中」正常終了
    setRunPdfTaskSuccess(state) {
      state.finished = true
      state.currentIndex = tasks.length - 1
    },
    // 「PDF作成中」エラー発生
    setRunPdfTaskError(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.finished = false
    },
    // 初期表示処理後に値の設定
    setProjectData(state, action: PayloadAction<jobSeekerPayload>) {
      const data = action.payload;
      state.runningProcessRequestData.jobSeekerByCompanyId = data.jobSeekerByCompanyId
      state.runningProcessRequestData.jobSeekerId = data.jobSeekerId
      state.runningProcessRequestData.setPrintManagementId = state.initRequestData.setPrintManagementId
      state.runningProcessRequestData.screenDisplayToggleFlag = '1'
    },
    // PDF作成処理
    mcbqs020RunningProcess(state, action: PayloadAction<MCBQS020RunningProcessRequest>) {
      return state
    },
  },
})

export const {
  initPdfProcess,
  updateCurrentTask,
  updateRequestData,
  setInitPdfProcessError,
  setRunPdfTaskStart,
  setRunPdfTaskSuccess,
  setRunPdfTaskError,
  setProjectData,
  mcbqs020RunningProcess,
} = pdfProcessSlice.actions

export default pdfProcessSlice.reducer

export const selectPdfProcessState = (state: RootState) => state.setOutputPdfProcess
